import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { formatDate, formatSocialPostEvent } from "../../../util/Helpers";
import { ForwardIcon } from "../../../util/Icons";

export const SocialPost = ({ post, isReply, selectPost }) => {
  return (
    <Col className="p-3 mb-3 bg-light rounded-lg">
      <Row className="align-items-center justify-content-center mb-3">
        <Col sm={1}>
          <div
            className="rounded-circle bg-secondary overflow-hidden"
            style={{ height: "40px", width: "40px" }}
          >
            <img src={post?.user?.imageUrl} className="w-100"/>
          </div>
        </Col>
        <Col>
          <div className="font-weight-bolder">{post?.user?.username}</div>
          <div>{formatDate(post.createdAt)}</div>
        </Col>
      </Row>
      <div className="mb-3">{formatSocialPostEvent(post)}</div>
      {post.content && (
        <div>
          <div className="bg-secondary p-3 w-100 rounded-lg">
            {post.title && (
              <Row>
                <div className="pb-3 w-100">{post.title}</div>
              </Row>
            )}
            <div>{post.content}</div>
          </div>
        </div>
      )}
      {!isReply && (
        <Row>
          <Col></Col>
          <Col sm={3}>
            <Button
              size="sm"
              variant="secondary"
              className="px-0 w-100 mt-3"
              onClick={() => selectPost(post)}
            >
              <div className="d-flex">
                <div className="text-center flex-fill font-weight-bolder px-2">
                  {post.replyCount} Replies
                </div>
                <ForwardIcon size={"14px"} className="mr-2" />
              </div>
            </Button>
          </Col>
        </Row>
      )}
    </Col>
  );
};
